export class SearchResponseModel {
  public content: any[] = [];
  public totalNumberOfPages: number = 1;
  public totalNumberOfContracts: number = 0;
  public allSearchResultIds: number[] = [];
  public totalResponseLenght: number = 0;
}
